import { TFunction } from 'i18next';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../../features';
import { actions } from '../../features/myDesign';
import { sendEvent } from '../../lib/google-analytics';
import { QRSource } from '../../lib/QrReader';
import { throttle } from '../../lib/utils';
import { ConfirmButton } from '../shared/buttons/ConfirmButton';

export const StartQrScanButton: React.FC<{ source: QRSource }> = ({ source }) => {
  const { t } = useTranslation('my_design');
  const history = useHistory();
  const { isLoading, uploadedMyDesign, errorType } = useSelector(
    (state: RootState) => state.myDesign
  );
  const dispatch = useDispatch();
  const handleCapture = useCallback(
    throttle(() => {
      const sourceLabel = source === 'camera' ? 'camera' : 'photo_library';
      if (uploadedMyDesign) {
        history.push(`/players/my-design/overwrite?source=${source}`);
        sendEvent('my_design_top_read_newqr', 'click', sourceLabel);
      } else {
        dispatch(actions.readMyDesign(source));
        sendEvent('my_design_top_read_qr', 'click', sourceLabel);
      }
    }, 1000),
    [uploadedMyDesign, dispatch, history]
  );

  const buttonText = getButtonText(source, t);

  return (
    <ConfirmButton disabled={isLoading || !!errorType} onClick={handleCapture}>
      {buttonText}
    </ConfirmButton>
  );
};

function getButtonText(source: QRSource, t: TFunction) {
  switch (source) {
    case 'camera':
      return t('button_read_qr_camera_00');
    case 'photoLibrary':
      return t('button_read_qr_photo');
  }
}
